<template>
  <!-- 优惠券，支持设置 金额，默认是元，设置title标题，时间区间
  描述字符串等。是否处于选中状态，是否处于激活/不可用
  
   -->
  <div class="coupon-container" v-bind:class="{disabled: disabled}" >
    <div class="body" v-bind:class="{selected: selected}" >
      <van-row class="head">
        <van-col span="8" class="text-center amount-box">
          <span class="amount">{{coupon && coupon.discount_yuan}}</span><span class="unit">元</span>
        </van-col>
        <van-col span="16" class="desc">
          <span class="title">{{coupon && coupon.description || ''}}</span>
          <span class="subtitle mt-2">有效期：{{formatDate(coupon && coupon.start_valid)}}-{{formatDate(coupon && coupon.end_valid)}}</span>
        </van-col>
      </van-row>
      <div class="foot" v-bind:class="{disabled: disabled}">
        <van-collapse v-model="activeNames">
          <van-collapse-item title="使用条件: 全场服务器通用；可赠送" name="0">
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, NavBar,Button,Row,Col,Field,CellGroup,Toast,Checkbox, CheckboxGroup ,Dialog, Popup, Picker, Collapse, CollapseItem} from 'vant';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'sby-coupon',
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col,
    [Row.name]: Row
  },
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    value(newVal) {
      this.coupon = newVal;
    }
  },
  data() {
    return {
      activeNames: ['1'],
      coupon: this.value
    }
  },
  methods: {
    formatDate(date) {
      if (date) {
        return moment(date).format('YYYY.MM.DD');
      } else {
        return '';
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sby-coupon.vue